import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  getInvoiceByPayment,
  getInvoiceDownloadUrl,
} from './invoices-api';

type Props = {
  paymentId: string;
  label?: string;
  variant?: 'default' | 'outline';
  size?: 'default' | 'sm';
};

export function InvoiceDownloadButton({
  paymentId,
  label = 'Télécharger la facture',
  variant = 'outline',
  size = 'sm',
}: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    setLoading(true);
    setError(null);
    try {
      const invoice = await getInvoiceByPayment(paymentId);
      if (!invoice) {
        setError('Facture non disponible');
        return;
      }
      const url = await getInvoiceDownloadUrl(invoice.id);
      window.open(url, '_blank', 'noopener');
    } catch {
      setError('Erreur de téléchargement');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        type="button"
        variant={variant}
        size={size}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? 'Chargement…' : label}
      </Button>
      {error && (
        <span role="alert" className="text-xs text-destructive">
          {error}
        </span>
      )}
    </div>
  );
}
